import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState, useContext } from "react";
import { auth } from "../../Firebase/Firebase";
import { getVolunteerIdByEmail, getUserRoleByEmail } from "../../services/api"; 

const AuthContext = React.createContext();

// Create and export the useAuth hook
export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [volunteerId, setVolunteerId] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, initializeUser);
    return unsubscribe;
  }, []);

  async function initializeUser(user) {

    setLoading(true);
    if (user) {
      setCurrentUser({ ...user });
      setUserLoggedIn(true);
      
      // Fetch additional user info from backend USING EMAIL
      try {
        const roleData = await getUserRoleByEmail(user.email); // Changed to use email
        setUserRole(roleData.role);
        
        if (roleData.role === 'volunteer') {
          const volunteerData = await getVolunteerIdByEmail(user.email); // Changed to use email
          setVolunteerId(volunteerData.id);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        // Don't block the app if backend calls fail
      }
    } else {
      setCurrentUser(null);
      setUserLoggedIn(false);
      setUserRole(null);
      setVolunteerId(null);
    }
    setLoading(false);
  }

  const value = {
    currentUser,
    userLoggedIn,
    volunteerId,
    userRole,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}